import { TaskDirection, TaskTypeDictionary } from '../models/Task/Task';
import { apiClientWithApi } from '../utils/http';

const taskTypeDictionaryEndpointByDirection: Record<TaskDirection, string> = {
  outbound: 'task/type/outbound',
  inbound: 'task/type/inbound',
};

export const loadTaskTypeDictionary = async (
  direction: TaskDirection,
): Promise<TaskTypeDictionary> => {
  const response = await apiClientWithApi.get<TaskTypeDictionary>(
    taskTypeDictionaryEndpointByDirection[direction],
  );

  return response.data;
};

export const loadOutboundTaskTypeDictionary = () =>
  loadTaskTypeDictionary('outbound');

export const loadInboundTaskTypeDictionary = () =>
  loadTaskTypeDictionary('inbound');
